import { Link, useLocation } from "react-router-dom";
import { Handshake, Briefcase, Mail, Linkedin } from "lucide-react";
import { LINKEDIN_JOBS_URL, LINKEDIN_URL } from "@/lib/api";

const ITEMS = [
  { to: "/partner", icon: Handshake, label: "Partner With Us", cls: "bg-ember text-white hover:bg-ember-bright", testid: "sticky-cta-partner" },
  { href: LINKEDIN_JOBS_URL, icon: Briefcase, label: "Open Roles", cls: "bg-hydro text-white hover:bg-hydro-glow hover:text-navy", testid: "sticky-cta-jobs" },
  { to: "/contact", icon: Mail, label: "Contact Us", cls: "bg-navy text-white hover:bg-navy-deep", testid: "sticky-cta-contact" },
  { href: LINKEDIN_URL, icon: Linkedin, label: "LinkedIn", cls: "bg-white text-navy border border-slate-200 hover:border-hydro hover:text-hydro", testid: "sticky-cta-linkedin" },
];

export function StickyCta() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;
  return (
    <aside className="fixed right-4 top-1/2 z-40 hidden -translate-y-1/2 flex-col gap-2.5 lg:flex" aria-label="Quick actions" data-testid="sticky-cta-bar">
      {ITEMS.map((item) => {
        const inner = (
          <>
            <item.icon className="h-5 w-5 shrink-0" aria-hidden="true" />
            <span className="max-w-0 overflow-hidden whitespace-nowrap text-xs font-semibold opacity-0 transition-all duration-300 group-hover:max-w-[8rem] group-hover:opacity-100 group-hover:pl-2">
              {item.label}
            </span>
          </>
        );
        const cls = `group flex items-center rounded-full p-3 shadow-lg transition-all duration-300 ${item.cls}`;
        return item.href ? (
          <a key={item.testid} href={item.href} target="_blank" rel="noopener noreferrer" aria-label={item.label} data-testid={item.testid} className={cls}>
            {inner}
          </a>
        ) : (
          <Link key={item.testid} to={item.to} aria-label={item.label} data-testid={item.testid} className={cls}>
            {inner}
          </Link>
        );
      })}
    </aside>
  );
}
